import { inject, Injectable } from '@angular/core';
import { DefaultService } from '@common/references/default.service';
import { TranslateService } from '@ngx-translate/core';
import { FullNamePipe } from '@common/pipe/full-name.pipe';
import { idField, ReferenceField } from '@common/references/reference-field';
import urlJoin from 'url-join';
import { environment } from '@environments/environment';
import {
  BookingImportComponent
} from '@modules/universal-billing/accounting/bookings/booking-import/booking-import.component';


@Injectable({providedIn: "root"})
export class BookingsService extends DefaultService<any> {
  backendName = 'datevbookings';
  title = 'Bookings';
  formComponent = BookingImportComponent;
  formModalOptions = {size: "lg", scrollable: true,};
  translate = inject(TranslateService);
  fullNamePipe = new FullNamePipe();

  fields: ReferenceField[] = [
    idField,
    {
      fieldName: 'transactionKey',
      label: 'TRANSACTION.TRANSACTION',
      iconClass: 'las la-key'
    },
    {
      fieldName: 'companyId',
      label: 'companyId',
      iconClass: 'las la-home'
    },
    {
      fieldName: 'bookingDate',
      label: 'RESIDENTS.DATE',
      iconClass: 'las la-check',
      viewType: "date"
    },
    {
      fieldName: 'documentNumber1',
      label: "DOCUMENTS",
      iconClass: 'las la-file',
    }, {
      fieldName: 'account',
      label: "RESIDENTS.ACCOUNT",
      iconClass: 'las la-building',
    },
    {
      fieldName: 'amount',
      label: 'DASHBOARD.AMOUNT',
      iconClass: 'las la-euro-sign',
      viewType: "money"
    },
    {
      fieldName: 'contraAccount',
      label: 'BOOKINGS.CREDITOR',
      iconClass: 'las la-calendar-alt',
    },

    {
      fieldName: 'description',
      label: 'BOOKINGS.DESCRIPTION',
      iconClass: 'las la-tags',
    },
  ]

  hasActions = false;
  hasAdd = false;
  hasEdit = false;
  hasView = false;
  hasDelete = false;


  getUrl(): string {
    return urlJoin(environment.apiUrl, '/datevbookings');
  }


}
